import { Theme } from "@mui/material";
import { scrollableStyleByColor } from "fe-common/ui/commonStyles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { MobileBreakpoint } from "../layout/breakpoints";
import { PatientColorMap } from "../layout/patientColorMap";
import { styled } from "@mui/material/styles";

export const WaveContainerBackground = styled("div")(
  ({
    theme,
    gradient,
    color,
    backgroundimg,
  }: {
    theme?: Theme;
    gradient: string;
    color: string;
    backgroundimg?: string;
  }) => ({
    background:
      gradient === "true"
        ? `radial-gradient(83.53% 86.88% at 45.87% -11.43%, ${PatientColorMap.GradLight} 0%, ${PatientColorMap.GradDark} 100%);`
        : backgroundimg
        ? `url(${backgroundimg}) space space`
        : color,
    position: "absolute",
    zIndex: 0,
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
  }),
);

export const MIN_LOWER_WAVE_HEIGHT = 125;

export const WaveHeaderBackground = styled("div")(
  ({
    theme,
    gradient,
    color,
  }: {
    theme?: Theme;
    gradient: string;
    color: string;
  }) => ({
    background: "white",
    position: "absolute",
    zIndex: 1,
    top: 0,
    left: 0,
    width: "100%",
    height: `calc(100% - max(15%, ${MIN_LOWER_WAVE_HEIGHT}px))`, // Remove one pixel to avoid vertical lines
    [theme.breakpoints.down(MobileBreakpoint)]: {
      height: `calc(100% - max(22%, ${MIN_LOWER_WAVE_HEIGHT}px))`,
    },
  }),
);

export const WaveHeader = styled("div")(
  ({
    theme,
    gradient,
    color,
    backgroundimg,
    textcolor,
  }: {
    theme?: Theme;
    gradient: string;
    color: string;
    backgroundimg?: string;
    textcolor?: string;
  }) => ({
    color: textcolor || "white",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 2,
    width: "100%",
    height: `calc(100% - max(15%, ${MIN_LOWER_WAVE_HEIGHT}px))`,
    background:
      gradient === "true"
        ? `radial-gradient(83.53% 86.88% at 45.87% -11.43%, ${PatientColorMap.GradLight} 0%, ${PatientColorMap.GradDark} 100%);`
        : backgroundimg
        ? `url(${backgroundimg}) space space`
        : color,
    padding: "50px",
    paddingBottom: "10px",
    ...(scrollableStyleByColor(KahunColorMap.White) as any),
    borderRadius: "0 0 0 80px",
    [theme.breakpoints.up(MobileBreakpoint)]: {
      height: `calc(100% - max(15%, ${MIN_LOWER_WAVE_HEIGHT}px))`,
    },
    [theme.breakpoints.down(MobileBreakpoint)]: {
      height: `calc(100% - max(22%, ${MIN_LOWER_WAVE_HEIGHT}px))`,
    },
  }),
);

export const WaveOuterWrapper = styled("div")(
  ({
    theme,
    gradient,
    color,
  }: {
    theme?: any;
    gradient: string;
    color: string;
  }) => ({
    position: "absolute",
    bottom: 0,
    zIndex: 3,
    width: "100%",
    height: `max(15%, ${MIN_LOWER_WAVE_HEIGHT}px)`,
    [theme.breakpoints.down(MobileBreakpoint)]: {
      height: `max(22%, ${MIN_LOWER_WAVE_HEIGHT}px)`,
      minHeight: "105px",
    },
    background: "transparent",
  }),
);

export const WaveInnerWrapper = styled("div")(({ theme }) => ({
  borderRadius: "0 80px 0 0",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  backgroundColor: "white",
}));

export const WaveResultOuterWrapper = styled("div")(
  ({ theme, ...props }: { theme?: Theme; gradient?: "true" | "false" }) => ({
    minHeight: "95px",
    [theme.breakpoints.down(MobileBreakpoint)]: {
      height: `145px`,
      minHeight: `145px`,
    },
    background:
      props.gradient === "true"
        ? `radial-gradient(153.07% 157.66% at 40.27% -15.06%, ${PatientColorMap.GradDark} 0%, ${PatientColorMap.GradLight} 100%);`
        : PatientColorMap.Header,
  }),
);

export const WaveResultInnerWrapper = styled("div")({
  borderRadius: "0 80px 0 0",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  backgroundColor: "white",
});
